
const imageUrl = (title) => {
  return `/imgs/tms/${title}.png`;
};

const banner = {
  title: '运输管理系统（TMS）',
  description: '云恋科技运输管理系统(TMS)集成了行业内最佳实践业务模型，专门为商业运输领域的客户提供成熟的运输管理信息化解决方案，适用于供应链制造、商贸零售、港口运输、干线整车运输、 零担配送等多种业务模式，实现运输的高效率、规范化、透明化、安全化。',
  img: imageUrl('banner')
};

const feature = [
  {
    title: '客户端',
    items: [
      {
        title: '轻松下单：',
        description: '简单、快捷、轻松下单。'
      },
      {
        title: '自助下单自动同步：',
        description: 'TMS配套的客户端，客户在TMS客户端下单后，信息会自动同步到TMS。'
      },
      {
        title: '实时跟踪运行状态：',
        description: '客户可在客户端查看派车情况，跟踪订单和车辆的运行状态。'
      },
      {
        title: '在线对账：',
        description: '运单完成后支持线上对账，节约线下对账时间。'
      },
    ]
  },
  {
    title: '移动端',
    items: [
      {
        title: '现场调度小程序：',
        description: '调度可在装货现场快速下单和派车，解决客户临时下单的问题，并降低人员成本。'
      },
      {
        title: '司机和监理APP：',
        description: 'TMS可直接派发任务给司机和监理，司机、监理可在配套的APP中实时反馈现场情况和相关回单照片等，提高信息流转效率。'
      },
      {
        title: 'GIS：',
        description: '实时查询所有营运货运车辆的定位和轨迹，时刻掌握运输状态。'
      },
    ]
  },
  {
    title: '供应商端',
    items: [
      {
        title: '直接派单:',
        description: '供应商端可直接派单给自有车辆和社会运输资源。'
      },
      {
        title: '同步反馈:',
        description: '供应商在线接单并派车，车辆信息同步反馈到TMS，并进行实时状态跟踪。'
      },
      {
        title: '轻松对账:',
        description: '支持在线对账，轻松完成对账过程。'
      }
    ]
  }
];

const func = [
  {
    title: '订单管理',
    img: imageUrl('func1'),
    description: '支持手动录入、Excel模板导入、第三方系统对接'
  },
  {
    title: '智能调度',
    img: imageUrl('func2'),
    description: '自定义配置运输规则及策略，智能调度、自动匹配运输资源'
  },
  {
    title: '跟踪管控',
    img: imageUrl('func3'),
    description: '支持实时查询运输轨迹，电子围栏管理'
  },
  {
    title: '回单管理',
    img: imageUrl('func4'),
    description: '支持司机拍照上传回单，系统自动存档，签收状态发送消息提醒'
  },
  {
    title: '可视化看板',
    img: imageUrl('func5'),
    description: '支持大屏显示，实时展示车辆状态、运力分布、订单执行进度'
  },
  {
    title: '计费与对账',
    img: imageUrl('func6'),
    description: '支持多种计费规则，自动计费与对账'
  },
  {
    title: '移动端',
    img: imageUrl('func7'),
    description: '支持APP或小程序，实时便捷高效掌握运营状态'
  },
  {
    title: '异常处理',
    img: imageUrl('func8'),
    description: '支持异常事件预警、上报和及时处理'
  },
  {
    title: '大数据分析',
    img: imageUrl('func9'),
    description: '提供标准化或定制化的报告和报表，提供实时、准确、可靠的运营数据'
  },
  {
    title: '基础设置',
    img: imageUrl('func10'),
    description: '支持货主、承运商、车辆、司机档案、业务规则配置等'
  },
];

const structure = imageUrl('structure');

export {banner, feature, func, structure};


// WEBPACK FOOTER //
// ./src/routes/ProductTMS/config.js